import type { JSX } from "react";

/**
 * SECURITY-PAGE-TRUTH-1 (TR-2026-10-16-8 A4) — the failed state for a
 * permissions tab. No toggles render here: defaults would look stored, and a
 * save from them would overwrite the organization's real values.
 */
export function PermissionsLoadFailed({ onRetry }: { onRetry: () => void }): JSX.Element {
  return (
    <div role="alert" className="rounded-lg border border-gray-200 bg-white px-4 py-3">
      <p className="text-sm font-medium text-gray-900">Couldn't load permissions</p>
      <p className="mt-1 text-xs text-gray-500">Nothing was changed. Try again.</p>
      <button
        type="button"
        onClick={onRetry}
        className="mt-3 min-h-[44px] rounded-md border border-gray-300 px-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
      >
        Retry
      </button>
    </div>
  );
}
